const defaultSettings = {
    general_site_logo: "loading.png",
    general_site_title: "SER",
    general_site_color: '#f7bf07',
    maintence: true,
}

export default defineNuxtPlugin(nuxtApp => {
    const settings = reactive({ ...defaultSettings })

    const runtimeConfigs = useRuntimeConfig()

    $fetch(`${runtimeConfigs.public.API_URL}/api/v1/settings/basic`)
        .then(data => {
            const loaded = (data || []).reduce((acc, item) => {
                acc[item.key] = item.value
                return acc
            }, {})
            Object.assign(settings, loaded)
        })
        .catch(error => {
            console.error('Erro ao carregar configurações:', error)
        })

    nuxtApp.provide('settings', settings)
})
